import React, { Component } from 'react'
// import ReactTable from "react-table"
import { connect } from 'react-redux'
// import settings from '../../../settings'
// import axios from 'axios'
import { deliveryOccasions, saveAltAddresses, saveGateAddresses } from '../redux/dataAnalyticsActions'
import dayjs from 'dayjs'
import { Well, Row, Col, ProgressBar, Grid, Glyphicon, DropdownButton, MenuItem } from 'react-bootstrap'

import AltAddresses from './AltAddresses'
import GateAddresses from './GateAddresses'
import { swalChoose } from '../../../common/components/Swaler'
import { deactivateContainer } from '../../../common/redux/collectionActions'
import { store } from '../../../store'
import TestDeliveryUsage from './TestDeliveryUsage'

const levels = {
  EXCELLENT: { color: '#28a745', min: 70, max: 100 },
  MODERATE: { color: '#ffc107', min: 50, max: 69 },
  DANGER: { color: '#dc3545', min: 0, max: 49 },
}

class AntiChurn extends Component {
    state = { parsedAddress: '', sortField: 'name', sortDirection: 1, timespan: 30 }

    componentWillMount() {
        if (!this.props.dataAnalytics.deliveryOccasions) {
            this.props.deliveryOccasions({ fromDate: dayjs().subtract(1, 'month').toISOString(), toDate: dayjs().toISOString() })
        }
    }

    onToggleAltAddresses = (lockId) => {
        const key = `are-lock-${lockId}-alt-addresses-editable`
        this.setState((prevState) => ({ [key]: !prevState[key] }))
    }

    onToggleGateAddresses = (lockId) => {
        const key = `are-lock-${lockId}-gate-addresses-editable`
        this.setState((prevState) => ({ [key]: !prevState[key] }))
    }

    onToggleTestDeliveryUsage = (lockId) => {
        const key = `is-lock-${lockId}-test-delivery-usage-viewable`
        this.setState((prevState) => ({ [key]: !prevState[key] }))
    }

    onAddAltAddresses = (textAreaContent, lockId) => {
        this.onToggleAltAddresses(lockId)

        const altAddresses = this.parseTextAreaContent(textAreaContent)

        this.props.saveAltAddresses(altAddresses, lockId)
    }

    onAddGateAddresses = (textAreaContent, lockId) => {
        this.onToggleGateAddresses(lockId)

        const gateAddresses = this.parseTextAreaContent(textAreaContent)

        this.props.saveGateAddresses(gateAddresses, lockId)
    }

    onDeactivateContainer = (lock) => {
        swalChoose('Säker?', `Vill du verkligen avaktivera ${lock.custom_name}?`, ['Ja', 'Avbryt']).then((r) => {
          if (r.dismiss) return

          store.dispatch(deactivateContainer(lock._id))
        })
    }

    parseTextAreaContent = (textAreaContent) => textAreaContent.split(';').reduce((acc, address) => address ? acc.concat({ street: address.trim().replace(/^\s+|\s+$/g, '') }) : acc, [])

    renderSeverityLevel = (qty, deliveriesExpectedPerWeek) => {
        const max = 100;
    
        const percentage = (qty / deliveriesExpectedPerWeek) * 100;
    
        if (percentage >= levels.EXCELLENT.min) return <ProgressBar bsClass="qprogresssuccess" label={`${percentage.toFixed(2)}%)`} now={percentage} max={max} />;
        if (percentage >= levels.MODERATE.min) return <ProgressBar bsClass="qprogresswarning" label={`(${percentage.toFixed(2)}%)`} now={percentage} max={max} />;
        if (percentage < levels.MODERATE.min) return <ProgressBar bsClass="qprogressdanger" label={`(${percentage.toFixed(2)}%)`} now={percentage} max={max} />;
    };
    

    updateParsedAddress = (e) => {
        const qlocxTagwords = ['qlocx', 'qloxc', 'qloc', 'qlo', 'q-locx', 'qlocx,']

        let value = e.target.value
        for (const word of qlocxTagwords) {
            const i = value.indexOf(word)
            if (i > -1) {
                value = value.replace(word, '').replace(/\s\s+/g, ' ').trim()
            }
        }

        this.setState({ parsedAddress: value })
    }

    render() {
        const { dataAnalytics: { deliveryOccasions }, locks } = this.props
        const { sortField, sortDirection, timespan } = this.state

        if (!deliveryOccasions) return <p style={{ marginLeft: 300 }}>Laddar...</p>
        const noDeliveryLocks = locks.filter((l=> l.sub_type === 'container' && !l.isCarrierDoor && !Object.keys(deliveryOccasions).includes(l._id)))

        const keyedLocks = this.props.locks.reduce((acc, val) => { acc[val._id] = val; return acc }, {})

        return (
          <Grid fluid>
            <Row>
              <Col xs={12} md={12} lg={12}>
                <Well>
                  <p>
                    När vi får en DLV från en transportör så räknas alla
                    leveranser från den transportören ihop på den timmen och
                    bildar ett "leveranstillfälle".
                  </p>

                  <b>Nivåer:</b>
                  <br />
                  {Object.entries(levels).map(([key, { color, min, max }]) => (
                    <span style={{ color }} key={key}>
                      {`${key}: ${min} - ${max}%`}
                      <br />
                    </span>
                  ))}

                  <br />

                  <div>
                    <h5>Skriv in adress och se query:</h5>
                    <input
                      type="text"
                      style={{ width: 250 }}
                      onChange={this.updateParsedAddress}
                    />
                    <p>{this.state.parsedAddress}</p>
                  </div>
                </Well>

                <div>
                  <DropdownButton
                    className="delivery-filter-container"
                    title="Sortering"
                    id="bg-nested-dropdown"
                  >
                    <MenuItem
                      onSelect={() => this.setState({ sortField: "name" })}
                      className="dropdown-menu-item"
                    >
                      <Glyphicon
                        glyph={`glyphicon glyphicon-${
                          sortField === "name" ? "check" : "unchecked"
                        }`}
                        style={{
                          color: "grey",
                          marginRight: "5px",
                          marginLeft: "5px",
                          float: "left",
                        }}
                      />
                      Namn
                    </MenuItem>
                    <MenuItem
                      onSelect={() => this.setState({ sortField: "color" })}
                      className="dropdown-menu-item"
                    >
                      <Glyphicon
                        glyph={`glyphicon glyphicon-${
                          sortField === "color" ? "check" : "unchecked"
                        }`}
                        style={{
                          color: "grey",
                          marginRight: "5px",
                          marginLeft: "5px",
                          float: "left",
                        }}
                      />
                      Färg
                    </MenuItem>
                  </DropdownButton>
                  <DropdownButton
                    className="delivery-filter-container"
                    title="Ordning"
                    id="bg-nested-dropdown"
                  >
                    <MenuItem
                      onSelect={() => this.setState({ sortDirection: 1 })}
                      className="dropdown-menu-item"
                    >
                      <Glyphicon
                        glyph={`glyphicon glyphicon-${
                          sortDirection === 1 ? "check" : "unchecked"
                        }`}
                        style={{
                          color: "grey",
                          marginRight: "5px",
                          marginLeft: "5px",
                          float: "left",
                        }}
                      />
                      Stigande
                    </MenuItem>
                    <MenuItem
                      onSelect={() => this.setState({ sortDirection: -1 })}
                      className="dropdown-menu-item"
                    >
                      <Glyphicon
                        glyph={`glyphicon glyphicon-${
                          sortDirection === -1 ? "check" : "unchecked"
                        }`}
                        style={{
                          color: "grey",
                          marginRight: "5px",
                          marginLeft: "5px",
                          float: "left",
                        }}
                      />
                      Fallande
                    </MenuItem>
                  </DropdownButton>
                  <DropdownButton
                    className="delivery-filter-container"
                    title={`Tidsspann (${timespan} dagar)`}
                    id="bg-nested-dropdown"
                  >
                    <MenuItem
                      onSelect={() => {
                        this.props.deliveryOccasions({
                          fromDate: dayjs()
                            .subtract(1, "month")
                            .toISOString(),
                          toDate: dayjs().toISOString(),
                        });
                        this.setState({ timespan: 30 });
                      }}
                      className="dropdown-menu-item"
                    >
                      <Glyphicon
                        glyph={`glyphicon glyphicon-${
                          timespan === 30 ? "check" : "unchecked"
                        }`}
                        style={{
                          color: "grey",
                          marginRight: "5px",
                          marginLeft: "5px",
                          float: "left",
                        }}
                      />
                      Månad
                    </MenuItem>
                    <MenuItem
                      onSelect={() => {
                        this.props.deliveryOccasions({
                          fromDate: dayjs()
                            .subtract(1, "week")
                            .toISOString(),
                          toDate: dayjs().toISOString(),
                        });
                        this.setState({ timespan: 7 });
                      }}
                      className="dropdown-menu-item"
                    >
                      <Glyphicon
                        glyph={`glyphicon glyphicon-${
                          timespan === 7 ? "check" : "unchecked"
                        }`}
                        style={{
                          color: "grey",
                          marginRight: "5px",
                          marginLeft: "5px",
                          float: "left",
                        }}
                      />
                      Vecka
                    </MenuItem>
                  </DropdownButton>
                </div>

                {Object.keys(deliveryOccasions)
                  .filter((o) => keyedLocks[o])
                  .sort((a, b) => {
                    if (sortField === "name")
                      return keyedLocks[a].custom_name >
                        keyedLocks[b].custom_name
                        ? sortDirection
                        : sortDirection * -1;
                    if (sortField === "color")
                      return (
                        (deliveryOccasions[a].deliveryOccasionsQty -
                          deliveryOccasions[b].deliveryOccasionsQty) *
                        sortDirection
                      );
                  })
                  .concat(noDeliveryLocks.map((l) => l._id))
                  .map((lockId) => {
                    const lock = keyedLocks[lockId];

                    if (!lock) return null; // borttagen enhet

                    const lockSummary = deliveryOccasions[lockId] || {
                      deliveryOccasionsQty: 0,
                      invalidQsignDeliveries: 0,
                      couldBeBookedToContainerInsteadOfGateDeliveries: 0,
                    };

                    return (
                      <Row
                        style={{
                          margin: "30px 0",
                          padding: 20,
                          border: "1px solid #006e78",
                          backgroundColor: "white",
                          borderRadius: 10,
                          width: "100%",
                        }}
                        key={lockId}
                      >
                        <Col sm={3} md={3} lg={3}>
                          {lock.custom_name}
                          <br />
                          {lock.address.street}
                          <br />
                          <AltAddresses
                            areAltAddressesEditable={
                              this.state[
                                `are-lock-${lockId}-alt-addresses-editable`
                              ]
                            }
                            altAddresses={lock.alternative_addresses}
                            lockId={lockId}
                            onAddAltAddresses={this.onAddAltAddresses}
                            onToggleAltAddresses={() =>
                              this.onToggleAltAddresses(lockId)
                            }
                          />
                          <button
                            onClick={() => this.onDeactivateContainer(lock)}
                            style={{ marginTop: 10 }}
                          >
                            <Glyphicon glyph="glyphicon glyphicon-remove" />{" "}
                            Avaktivera
                          </button>
                        </Col>
                        <Col sm={9} md={9} lg={9}>
                          {this.renderSeverityLevel(
                            lockSummary.deliveryOccasionsQty,
                            lock.unit_application.primary.expectedDeliveriesPerWeek
                          )}
                          <br />
                          Leveranser som fått invalid QSign:{" "}
                          {lockSummary.invalidQsignDeliveries}
                          <br />
                          Grindleveranser som hade kunnat gå till container:{" "}
                          {
                            lockSummary.couldBeBookedToContainerInsteadOfGateDeliveries
                          }
                          <br />
                          Förväntade leveranser/vecka:{" "}
                            {lock.unit_application.primary.expectedDeliveriesPerWeek}
                          <GateAddresses
                            areGateAddressesEditable={
                              this.state[
                                `are-lock-${lockId}-gate-addresses-editable`
                              ]
                            }
                            gateAddresses={lock.gate_addresses}
                            lockId={lockId}
                            onAddGateAddresses={this.onAddGateAddresses}
                            onToggleGateAddresses={() =>
                              this.onToggleGateAddresses(lockId)
                            }
                          />
                          <TestDeliveryUsage
                            lockId={lockId}
                            isTestDeliveryUsageOpen={
                              this.state[
                                `is-lock-${lockId}-test-delivery-usage-viewable`
                              ]
                            }
                            onToggleTestDeliveryUsage={() =>
                              this.onToggleTestDeliveryUsage(lockId)
                            }
                          />
                        </Col>
                      </Row>
                    );
                  })}
              </Col>
            </Row>
          </Grid>
        );
    }

}


const mapProps = state => {
    return {
        locks: state.collectionData.locks,
        dataAnalytics: state.dataAnalytics
    }
}

const mapDispatch = dispatch => {
    return {
        deliveryOccasions: (...args) => dispatch(deliveryOccasions(...args)),
        saveAltAddresses: (addresses, lockId) => dispatch(saveAltAddresses(addresses, lockId)),
        saveGateAddresses: (addresses, lockId) => dispatch(saveGateAddresses(addresses, lockId)),
    }
}

export default connect(mapProps, mapDispatch)(React.memo(AntiChurn))
